import { APISubmode } from '../../../../../api/types';

const processUserInput = (text, submode) => {
    let processedInput = text;
    if (submode === APISubmode.MAX) {
        processedInput = text
            .replace(/([0-9]{4})[.-]{1}([0-9]{1,2})[.-]{1}([0-9]{1,2})/g, '$1.$2.$3')
            .replace(/([0-9]{1,2})[.-]{1}([0-9]{1,2})[.-]{1}([0-9]{4})/g, '$1.$2.$3');
    }
    return processedInput;
};

export default processUserInput;
